import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';

const $eventListEl = $('.event-list');

$(function () {
    if ($eventListEl.length > 0) {
        $eventListEl.each(function () {
            eventList($(this));
        });
    }
});

const eventList = (listEl) => {
    const filter = {
        page: 1,
        limit: listEl.data('limit'),
        categories: listEl.data('categories'),
        category: '',
        search: '',
        dateStart: '',
        dateEnd: '',
        lang: listEl.data('lang'),
    };

    bindPagination(listEl, filter);
    bindEventFilter(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
    const data = await getEvents(filter);
    element.find('.event-list__content').html(data.html);

    if (scrollTop === true) {
        smoothscroll(element, 'header');
    }
};

const bindPagination = (element, filter) => {
    element.on('click', '.pagination__item', function () {
        filter.page = $(this).data('page');
        reRenderList(element, filter, true);
    });
};

const bindEventFilter = (element, filter) => {
    element.on('click', '.event-filter__item', function () {
        const $thisEl = $(this);
        $('.event-filter__item.selected').removeClass('selected');
        $thisEl.addClass('selected');

        filter.page = 1;
        filter.category = $thisEl.data('id');
        reRenderList(element, filter);
    });

    element.on(
        'input',
        "input[name='event-filter-input-search']",
        debounce(function () {
            const $input = $(this);
            filter.page = 1;
            filter.search = $input.val();

            if (filter.search) {
                $input.parent().addClass('has-value');
            } else {
                $input.parent().removeClass('has-value');
            }
            reRenderList(element, filter);
        })
    );

    element.on('click', "button[name='event-filter-input-reset']", function () {
        element.find("input[name='event-filter-input-search']").val('').trigger('input');
    });

    element.on('change', "input[name='event-filter-input-from']", function () {
        const $input = $(this);
        filter.page = 1;
        filter.dateStart = $input.val();

        if (filter.dateStart) {
            $input.parent().addClass('has-date-from');
        } else {
            $input.parent().removeClass('has-date-from');
        }
        reRenderList(element, filter);
    });

    element.on('change', "input[name='event-filter-input-to']", function () {
        const $input = $(this);
        filter.page = 1;
        filter.dateEnd = $input.val();

        if (filter.dateEnd) {
            $input.parent().addClass('has-date-to');
        } else {
            $input.parent().removeClass('has-date-to');
        }
        reRenderList(element, filter);
    });

    element.on('click', "button[name='event-filter-date-reset']", function () {
        element.find("input[name='event-filter-input-from'],input[name='event-filter-input-to']").val('').trigger('change');
    });
};

const getEvents = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/nitra/v1/event-list/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
